import React, { Component } from 'react';

class AssignedWork extends Component {
  constructor() {
    super();
    this.state = {
      isSmallScreen: false,
      isSidebarShow: false,
      config: [],
    };
  }

  componentDidMount() {

  }

  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" id="prefix__icon_s_assigned-work" width="30" height="30" viewBox="0 0 30 30">
        <g id="prefix__Group_91" data-name="Group 91" transform="translate(6.375 3.75)">
            <path id="prefix__Path_123" d="M72.559 362.1H61.305a3 3 0 0 1-3-3v-16.506a3 3 0 0 1 3-3h11.254a3 3 0 0 1 3 3V359.1a3 3 0 0 1-3 3zm-11.253-21a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h11.253a1.5 1.5 0 0 0 1.5-1.5v-16.506a1.5 1.5 0 0 0-1.5-1.5z" className="prefix__cls-1" data-name="Path 123" transform="translate(-58.307 -339.597)"/>
            <path id="prefix__Path_124" d="M67.307 362.347a.75.75 0 0 1 .747-.75h9.006a.75.75 0 0 1 0 1.5h-9.006a.746.746 0 0 1-.747-.75z" className="prefix__cls-2" data-name="Path 124" transform="translate(-63.932 -353.347)"/>
            <path id="prefix__Path_125" d="M67.307 372.347a.75.75 0 0 1 .747-.75h9.006a.75.75 0 0 1 0 1.5h-9.006a.746.746 0 0 1-.747-.75z" className="prefix__cls-2" data-name="Path 125" transform="translate(-63.932 -359.597)"/>
            <path id="prefix__Path_126" d="M67.307 382.347a.75.75 0 0 1 .747-.75h9.006a.75.75 0 0 1 0 1.5h-9.006a.746.746 0 0 1-.747-.75z" className="prefix__cls-2" data-name="Path 126" transform="translate(-63.932 -365.847)"/>
            <path id="prefix__Path_127" d="M82.307 352.347a.749.749 0 0 1 .751-.75h3.373a.75.75 0 1 1 0 1.5h-3.373a.749.749 0 0 1-.751-.75z" className="prefix__cls-2" data-name="Path 127" transform="translate(-73.307 -347.097)"/>
            <path id="prefix__Path_128" d="M68.908 351.722a.784.784 0 0 1-.078 0 .751.751 0 0 1-.559-.35L67.42 350a.75.75 0 1 1 1.274-.792l.342.549 1.856-1.93a.75.75 0 1 1 1.081 1.04l-2.524 2.625a.75.75 0 0 1-.541.23z" className="prefix__cls-1" data-name="Path 128" transform="translate(-63.932 -344.597)"/>
        </g>
        <path id="prefix__Rectangle_38" d="M0 0H30V30H0z" data-name="Rectangle 38" style={{ fill: 'none' }}/>
    </svg>

    );
  }
}

export default AssignedWork;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/components/Layout/components/AssignedWork/index.js
 **/